import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { ViewerEditorIconsConstants } from '../../constants/viewer-editor-icons.constants';
import { IProject, ProjectUser } from '../../../shared/models/project.model';
import {
  IOpenTransferOwnershipConfirmationModal,
  TransferOwnershipOpenedFrom,
} from '../../../shared/commands/OpenTransferOwnershipConfirmationModal';
import { User } from '../../../shared/models/user';

declare var jQuery: any;

@Component({
    selector: 'app-pl-transfer-ownership-modal',
    templateUrl: './transfer-ownership-modal.component.html',
    styleUrls: ['./transfer-ownership-modal.component.scss'],
    standalone: false
})
export class TransferOwnershipModalComponent {

  roleIcons = ViewerEditorIconsConstants;

  @ViewChild('transferOwnershipModal') transferOwnershipModalEl: ElementRef;

  @Input() user: User;
  @Input() project: IProject;

  @Output() transferOwnership = new EventEmitter<IOpenTransferOwnershipConfirmationModal>();

  onTransferOwnership(user: ProjectUser) {
    this.transferOwnership.next({ openedFrom: TransferOwnershipOpenedFrom.transferOwnership, user });
  }

  openModal() {
    jQuery(this.transferOwnershipModalEl.nativeElement).modal('show');
  }

  closeModal() {
    (document.activeElement as HTMLElement)?.blur();
    jQuery(this.transferOwnershipModalEl.nativeElement).modal('hide');
  }
}
